export default __webpack_public_path__ + "static/media/arrow_back_ios_white_24dp.dee96783.svg";